import script from "./PoolsTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./PoolsTable.vue?vue&type=script&setup=true&lang=ts"

import "./PoolsTable.vue?vue&type=style&index=0&id=08eb838e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08eb838e"]])

export default __exports__